export default __webpack_public_path__ + "static/media/solution_40.9428ebdc.svg";